import { getProduitFaceLc } from '@/api/PanneauxLc';
import { getProduitAssocie } from '@/api/devis';
import genererLigneCommande from '@/services/devisCommandes/genererLigneCommande';
import miseAJourArticle from '@/services/devisCommandes/miseAJourArticle';
import * as devisConf from '@/configuration/devisConf';
import ajoutOrdre from '@/services/devisCommandes/ajoutOrdre';
import calculDateFin from '@/services/general/calculDateFin';
import returnLiaisonTarif from '@/services/catalogue/getLiaisonTarifADate';
import * as produitConf from '@/configuration/produitConf';
import updateQuantiteDispo from '@/services/devisCommandes/updateQuantiteDispo';
import genererLiaisonTarifFromProduitAssocie from '@/services/devisCommandes/genererLiaisonTarifFromProduitAssocie';
import { getAffectionOfProductFace, updateAffection } from '@/services/affectation/affectation';
import { gestionLiaisonsTarifProduitsAssocies } from '@/services/devis/gestionProduitsAssocies';
import generationToutesLignesCommandes from './genererToutesLignesCommande';

async function generationLigneCommandeRegroupement(
  produitFace, produitsAssocies, devisCommande, produit, listIdProduits,
  tauxTvaDefault,
) {
  const nouvelleLigneCommande = genererLigneCommande();
  miseAJourArticle(nouvelleLigneCommande, tauxTvaDefault);
  nouvelleLigneCommande.quantiteDispo = 1;
  nouvelleLigneCommande.affectation = [];
  nouvelleLigneCommande.logo = null;
  nouvelleLigneCommande.title = produitsAssocies && produitsAssocies.libelle
    ? produitFace.reference + ' - ' + produitsAssocies.libelle : produitFace.reference;
  nouvelleLigneCommande.produitId = produitFace.id;
  nouvelleLigneCommande.produit = produitFace;
  nouvelleLigneCommande.tauxTva = 0;
  nouvelleLigneCommande.dateDebut = produit.extensionOpportunite.dateDisponibilite;
  if (produit.extensionOpportunite.dateFin) {
    nouvelleLigneCommande.dateFin = produit.extensionOpportunite.dateFin;
  } else {
    const dateFin = calculDateFin(
      nouvelleLigneCommande.dateDebut, produitsAssocies.quantite, produitsAssocies.uniteVente,
    );
    if (dateFin) nouvelleLigneCommande.dateFin = dateFin;
    else {
      nouvelleLigneCommande.dateFin = calculDateFin(
        nouvelleLigneCommande.dateDebut, 1, devisConf.ANNEE,
      );
    }
  }
  nouvelleLigneCommande.libelle = produitFace.libelle;
  nouvelleLigneCommande.type = devisConf.REGROUPEMENT;
  nouvelleLigneCommande.typeProduit = produitConf.CATEGORIE_UNITAIRE;
  nouvelleLigneCommande.masqueLigne = false;
  if (produitsAssocies && produitsAssocies.produitEnfant) {
    await gestionLiaisonsTarifProduitsAssocies(
      produitsAssocies, produit, listIdProduits, produitConf.CATEGORIE_UNITAIRE);
    nouvelleLigneCommande.lignesCommande = generationToutesLignesCommandes(
      produitsAssocies, produit.extensionOpportunite.typeDeRemise, tauxTvaDefault,
    );
  } else nouvelleLigneCommande.lignesCommande = [];
  return nouvelleLigneCommande;
}

export default async function ajoutLignesCommandeProduitFace(
  devisCommande, facesLc, listIdProduits, ordre, tauxTvaDefault,
) {
  const response = await getProduitFaceLc(facesLc.extensionOpportunite.faceSelectionne.facNum);
  const produitFace = response.data.result;
  let idProduitDefault = produitFace.produitFace.produitParDefautId;
  let liaisonTarif = {};
  if (idProduitDefault === null) {
    idProduitDefault = listIdProduits.produit;
  }
  if (idProduitDefault !== null && produitFace.liaisonsTarif.length > 0) {
    liaisonTarif = returnLiaisonTarif(produitFace, idProduitDefault, new Date());
  }
  if (!liaisonTarif) {
    const produitAssocie = (await getProduitAssocie(idProduitDefault))
      .data.result;
    liaisonTarif = genererLiaisonTarifFromProduitAssocie(
      produitAssocie,
    );
  }
  const nouvelleLignesCommande = await generationLigneCommandeRegroupement(
    produitFace, liaisonTarif, devisCommande, facesLc, listIdProduits, tauxTvaDefault,
  );
  ajoutOrdre(nouvelleLignesCommande, devisCommande.lignesCommande.length, ordre);
  const affectationList = await getAffectionOfProductFace([nouvelleLignesCommande]);
  await updateAffection(
    nouvelleLignesCommande,
    devisCommande,
    affectationList[nouvelleLignesCommande.produitId],
  );
  updateQuantiteDispo(nouvelleLignesCommande);
  return nouvelleLignesCommande;
}



// WEBPACK FOOTER //
// ./src/services/devis/ajoutProduit/ajoutProduitFace.js